module.exports = __webpack_public_path__ + "static/media/cloud-bad-connection.e1bb2037.svg";